<div class="supplementary-equipment-details">
    <div class="options-list">
        <div class="form-box">
            <sc-padding>
                <sc-flex [vertical]="true" [stretchContent]="true">
                    <ng-container *ngFor="let se of supplementaryEquipment; let i = index">
                        <sc-content-spacer [vertical]="true" *ngIf="i > 0"></sc-content-spacer>
                        <div class="form-checkbox">
                            <div class="checkbox-label">
                                <mat-checkbox [disabled]="true" [ngModel]="true">
                                    {{se.dictionaryKey | translate:[se.dictionaryKey,
                                    translationService.language]}}
                                </mat-checkbox>
                            </div>
                            <mat-form-field class="checkbox-value mat-form-field-readonly" *ngIf="se.parameter1Value">
                                <input matInput [(ngModel)]="se.parameter1Value" [ngModelOptions]="{standalone: true}"
                                    placeholder="{{se.parameter1DictionaryKey | translate: [ se.parameter1DictionaryKey, translationService.language]}}"
                                    [readonly]="true">
                            </mat-form-field>
                        </div>
                    </ng-container>
                </sc-flex>
            </sc-padding>
        </div>
    </div>
</div>